import { ProductMovementHistoryService } from '../api/services/ProductMovementHistoryService';
import type { ProductHistoryListPaginatedResponseDto } from '../api/models/ProductHistoryListPaginatedResponseDto';
import type { CancelablePromise } from '../api/core/CancelablePromise';

export interface SearchHistoryByRelatedEntityOptions {
  relatedEntityType: string;
  relatedEntityId: number;
  page?: number;
  limit?: number;
  sortBy?: 'performed_at' | 'event_type';
  sortOrder?: 'ASC' | 'DESC';
}

/**
 * Named-params wrapper around the generated `productMovementHistoryControllerSearch`
 * client for the common "history of one related entity" case. Avoids a long list of
 * positional `undefined` arguments at call sites.
 */
export function searchHistoryByRelatedEntity({
  relatedEntityType,
  relatedEntityId,
  page = 1,
  limit = 50,
  sortBy = 'performed_at',
  sortOrder = 'DESC',
}: SearchHistoryByRelatedEntityOptions): CancelablePromise<ProductHistoryListPaginatedResponseDto> {
  return ProductMovementHistoryService.productMovementHistoryControllerSearch(
    undefined, // productId
    undefined, // warehouseProductId
    undefined, // productCode
    undefined, // serialNumber
    undefined, // eventType
    undefined, // startDate
    undefined, // endDate
    undefined, // userId
    undefined, // locationId
    relatedEntityType,
    relatedEntityId,
    undefined, // transferCode
    undefined, // orderCode
    undefined, // recordCode
    undefined, // search
    page,
    limit,
    sortBy,
    sortOrder,
  );
}
